import Ext from "Ext";

/**
 * Gradient button implementation, rendered as an div tag with span with text inside.
 */
const GradientButton = Ext.extend(Ext.Button, {
    overCls: 'hover',
    buttonSelector: "span:first-child",
    icon: "",

    initComponent: function() {
        GradientButton.superclass.initComponent.call(this);
        this.template = new Ext.Template('<div><span>{0}</span></div>');
    }
});

Ext.reg("at_gradient_button", GradientButton);

export default GradientButton;


// WEBPACK FOOTER //
// ./web/js/controls/at_gradient_button.js